import { homeConstants } from '../constants';

export function homeReducers(state = {}, action) {
    switch (action.type) {
            
        // Get One-Click Action Details
        
        case homeConstants.getOneClickActionDetails_request:
            return {
                ...state,
                getOneClickActionDetails_requesting: true, getOneClickActionDetails_status: false,
            }
        case homeConstants.getOneClickActionDetails_success:
            return {
                ...state,
                getOneClickActionDetails_requesting: false, getOneClickActionDetails_status: true,
                oneClickActionDetails: action.details.data
            }
        case homeConstants.getOneClickActionDetails_failure:
            return {
                ...state,
                getOneClickActionDetails_requesting: false, getOneClickActionDetails_status: false, 
            }

        // Get Company Details
        
        case homeConstants.getCompanyDetails_request:
            return {
                ...state,
                getCompanyDetails_requesting: true, getCompanyDetails_status: false,
            }
        case homeConstants.getCompanyDetails_success:
            return {
                ...state,
                getCompanyDetails_requesting: false, getCompanyDetails_status: true,
                companyDetails: action.details.data,
                companyDetailsHeaders: action.details.headers,
            }
        case homeConstants.getCompanyDetails_failure:
            return {
                ...state,
                getCompanyDetails_requesting: false, getCompanyDetails_status: false, 
            }

        default:
            return state;
    }
}